module.exports = __webpack_public_path__ + "img/corriente_c.1a39a2bf.svg";